const classes = {
  container: {
    marginBottom: 2,
  },
};

export default classes;
